const CustomComponentContext = require.context(
  './custom-components',
  false,
  /\.(js|ts)x?/
);

export async function loadCustomComponents(callback: Function) {
  CustomComponentContext.keys().forEach(async key => {
    const fileName = getFileNameForKey(key);
    const cmp = await CustomComponentContext(key);
    callback(fileName, cmp[fileName]);
  });
}

function getFileNameForKey(key: string) {
  return key.substr(key.lastIndexOf('/') + 1, key.lastIndexOf('.') - 2);
}
